<p class="[&>nz-text-copy>button]:flex [&>nz-text-copy>button]:items-center" nz-typography nzCopyable [nzCopyText]="id" [nzCopyIcons]="[icon_copy, icon_check]"></p>

<ng-template #icon_copy>
  <svg-icon key="copy" fontSize="18px"></svg-icon>
</ng-template>
<ng-template #icon_check>
  <svg-icon key="check" fontSize="18px" class="text-green-500"></svg-icon>
</ng-template>
